import { FALLBACK_LOGO, displayBrandName, isPrimaryBrandHost } from '../lib/brand';
import { useSettings } from '../context/SettingsContext';
import ResponsiveImg from './ResponsiveImg';

export function useBrand() {
  const { site } = useSettings();
  const name = displayBrandName(site?.brand_name);
  const raw = String(site?.brand_logo || '').trim();
  const rawM = String(site?.brand_logo_mobile || '').trim();
  const fallback = (!raw && isPrimaryBrandHost()) ? FALLBACK_LOGO : '';
  return {
    name,
    logo: raw || fallback,
    logoMobile: rawM || raw || fallback,
  };
}

const BrandLogo = ({ className = 'h-8 w-auto object-contain', ...rest }) => {
  const { name, logo, logoMobile } = useBrand();
  if (!logo && !logoMobile) {
    return <span className={`font-display font-extrabold tracking-tight truncate ${className}`} {...rest}>{name}</span>;
  }
  return (
    <span className="inline-block max-w-full">
      <ResponsiveImg desktop={logo} mobile={logoMobile} alt={name} className={className} {...rest} />
    </span>
  );
};

export default BrandLogo;
